exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle-btn {\n  display: inline-block;\n  outline: 0;\n  width: 36px;\n  height: 20px;\n  position: relative;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background: #DFE1E6;\n  border-radius: 2em;\n  padding: 2px;\n  transition: all 0.4s ease;\n  border: none; }\n\n.toggle-btn::after {\n  left: 0;\n  position: relative;\n  display: block;\n  content: '';\n  width: 50%;\n  height: 100%;\n  border-radius: 2em;\n  background: #fbfbfb;\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease;\n  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1); }\n\n.toggle-btn.toggle-btn-on::after {\n  left: 50%; }\n\n.toggle-btn.toggle-btn-on {\n  background: #3B94F0; }\n\n.toggle-btn.toggle-btn-on:active {\n  box-shadow: none; }\n\n.toggle-btn.toggle-btn-on:active::after {\n  margin-left: -0.8em; }\n\n.toggle-btn:active::after {\n  padding-right: 0.8em; }\n\n.toggle-input {\n  display: none; }\n\n.toggle-btn-on-disabled {\n  background: #80e1cd; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toggle-button/toggle-button.component.scss
// module id = 957
// module chunks = 22